// https://github.com/giantcz/gia
// Add import to js/components
import Component from 'gia/Component'
import { gsap, Power4 } from "gsap/all";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import Swiper, { Navigation, Pagination, Lazy, Autoplay, EffectFade, A11y } from 'swiper';
Swiper.use([Navigation, Pagination, Lazy, Autoplay, EffectFade, A11y]);

gsap.registerPlugin(ScrollTrigger);


export default class HomeComponent extends Component {
  
  constructor(element) {
    super(element);
    this.ref = {
      slider: '',
      logo: '',
      slides: [],
      text: [],
      slideContainer: ''
    }
  }
  
  async require() {}
  
  mount() {
    // this.introScreen() 
    const swiper = new Swiper(this.ref.slideContainer, {
      // Swiper settings
      loop: true,
      autoplay: true,
      slidesPerView: 1,
      allowTouchMove: false,
      speed: 1500,
      delay: 6500,
      
      // Swiper.Lazy settings
      lazy: {
        loadPrevNext: true,
        loadPrevNextAmount: 1,
      },

      a11y: true,
      
      // Swiper.EffectFade settings
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      },
      
    });
    
    swiper.init();
    
    
    
  }
  
  introScreen() {
    $('body', 'html').css('overflow', 'hidden');
    
    let tl = gsap.timeline({
      ease: Power4.easeInOut,
      onComplete: function () {
        $('body', 'html').css('overflow', 'auto');
      }
    })
    tl
      .from(['.home-intro-wrapper .main-logo .logo-img', '.home-intro-wrapper .main-logo .logo-text'], { fill: '#eee', duration: 1.5, delay: 1 })
      .from(['.home-intro-text'], { opacity: 0, duration: 1, scale: 0 })
      .to(['.home-intro-wrapper '], { duration: 0.3, y: '-100%' })
    
    
  }
  
}